import React, {lazy, Suspense} from 'react'

const ReligiousOrderPageLazy = lazy(() =>
    import('./ReligiousOrderPage')
)

const ReligiousOrderPage = props => (
    <Suspense fallback={null}>
        <ReligiousOrderPageLazy {...props} />
    </Suspense>
)

export default ReligiousOrderPage
